import React from "react"
import Tooltip from "rc-tooltip"

const serializers = {
  marks: {
    tooltip: ({ mark, children }) => {
      if (!mark || !children) {
        return "Missing tooltip description!"
      }
      // console.log("mark", mark)
      return (
        <Tooltip
          trigger="hover"
          placement="top"
          mouseLeaveDelay={0}
          defaultVisible={false}
          overlay={mark.description}
          destroyTooltipOnHide={true}
          overlayClassName="relative inline-block px-4 py-1 bg-primary text-white rounded-lg shadow-md tooltip-arrow"
        >
          <span className="border-b-2 border-dotted	border-gray-400 cursor-pointer hover:text-gray-700">
            {children[0]}
          </span>
        </Tooltip>
      )
    },
  },
}

export { serializers }
